import config from '../../constants/config';
import { getCleanUsername } from '../helpers/utils';

const configDomain = config.DOMAIN;
const parsed = configDomain.replace(/https?:\/\//, '').replace(/\/$/, '');

export default {
  and: 'y',
  SignUp: 'Registrarse',
  LogIn: 'Iniciar\u00A0Sesión',
  LOGIN: 'INICIAR\u00A0SESIÓN',
  Close: 'Cerrar',
  Ok: 'OK',
  Back: 'Atrás',
  He: 'E',
  She: 'Ella',
  Him: 'E',
  Her: 'Ella',
  Find: 'Encontrar',
  Thanks: 'Gracias',
  SingUpLanding: 'Toca aquí para encontrar',
  LogInLanding: '¿Ya eres miembro? Inicia session aquí',
  TitleLanding: '¿Cansado de viejos sitios de citas?',
  SubTitleLanding:
    '¡Nosotros también! Descubre una nueva experiencia en ' +
    config.TITLE +
    'con características como estas:',
  logInWithApple: 'Sigue con Apple',
  mailIsConfirmed:
    '¡Felicidades! Su cuenta ha sido activada con éxito. Gracias por verificar su correo electrónico. Ahora puede disfrutar de acceso completo a nuestros servicios.',
  SignUpWithEmail: 'Registrarse con correo electrónico',
  reactivateAccount: 'Reactivar cuenta',
  welcomeBack: 'Bienvenido nuevamente',
  prevYouDeactivYourAcc: 'Previamente, desactivaste tu cuenta',
  doUwantToReacYourAcc: 'Quieres reactivar tu cuenta',
  yesReactivateMyAcc: 'Si, reactivar mi cuenta',
  noKeepDeactivated: 'No, mantenerla desactivada',
  signUpWithApple: 'Sigue con Apple',
  TermsOfService: 'Términos\u00A0de\u00A0Servicio',
  PrivacyPolicy: 'Política\u00A0de\u00A0Privacidad',
  JoinToday: 'Únete Hoy',
  firstName: 'Nombre',
  yourFirstName: 'Por favor dime tu nombre',
  EmailAddress: 'Direccion de correo electrónico',
  password: 'Contraseña',
  EnterEmailAddress: 'Ingresar dirección de correo electrónico',
  EnterPassword: 'Ingresar contraseña',
  PleaseEnterValidEmail: 'Por favor ingresar un correo electrónico válido',
  PleaseEnterPassword: 'Por favor ingresar contraseña',
  LandPageHeader: '¿Listo para una nueva aventura?',
  LandPageSubHeader:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) +
    ' Citas conecta ' +
    config.NICHE_SINGULAR +
    ' solteros buscando un romance',
  LandPageLegal: 'Al iniciar sesión, aceptas nuestros',
  LandPageAllDevices: 'Disponible en Todos los Dispositivos',
  ForgotYourPassword: '¿Olvidaste tu contraseña?',
  or: 'o',
  Save: 'Guardar',
  views: 'Vistas',
  view: 'Vista',
  ViewedMyProfile: 'Vieron Mi Perfi',
  ViewProfile: 'Ver perfi',
  UnmatchDelete: 'Desempatar / Eliminar',
  UnmatchDeleteQuestionMark: '¿Desempatar/Eliminar?',
  UnmatchDeleteText:
    '¿Seguro que quieres Desempatar/Eliminar? Ya no tendrás acceso a tu historial de chat con ',
  YesUnmatchDelete: 'Si, Desempatar/Eliminar',
  IViewed: 'Vi',
  ViewedMe: 'Me Vieron',
  LikesMe: 'Le Gusto',
  Mutual: 'Mutuo',
  MyLikes: 'Mis Me Gusta',
  Chat: 'Chat',
  Flirts: 'Coqueteos',
  Send: 'Enviar',
  typing: 'escribiendo',
  UpgradeToVIP: 'Actualizar a VIP',
  TypeAMessageHere: 'Escribe un mensaje aquí',
  FeaturesChat:
    config.NICHE_SINGULAR.replace(/\b\w/g, (c) => c.toUpperCase()) + ' Chat',
  SendMessagesToWhoYouWant: 'Envía mensajes a quién desees',
  SeeWhoIsInterestedInYou: 'Ver quién está interesado en ti',
  SeeWhoIsReallyInterestedInYou: 'Mira quién está realmente interesado en ti',
  IncreaseYourChancesWithAFlirt: 'Incrementa tus posibilidades con un Coqueteo',
  GetDatesFast: 'Consigue citas rápidamente diciendo Sí o No',
  FeaturesIncluded: '¿En Movimiento?',
  Matches: 'Empates',
  Likes: 'Me Gustan',
  QuickMatch: 'Empate Rápido',
  Search: 'Buscar',
  Favorite: 'Favorito',
  Favorites: 'Favoritos',
  Browse: 'Explorar',
  MyProfile: 'Mi Perfi',
  Settings: 'Configuración',
  // Logout
  LogoutH1: 'Has Finalizado Sesión Exitosamente',
  LogoutP: 'Se te echará de menos...',
  LogoutButton: 'Inicia sesión nuevamente',
  // Unsubscribe
  tooManyEmails: 'Demasiados correos',
  enterYourEmailBelowToUnsub:
    'Ingresa tu correo electrónico debajo para darte de baja',
  unsubscribe: 'Darse de baja',
  unsubscribeSuccess: 'Dado de baja exitosamente',
  youWillNoLongerReceiveAnyEmailFromUs:
    'Ya no recibirás correo electrónico de nosotros',
  unSubByAccident: 'Dado de baja por accidente',
  reSubHere: 'Volver a suscribirse aquí',
  helpUsGetBetter: 'Ayúdanos a mejorar',
  tellUsWhyYouUnSub: 'Dinos por qué te diste de baja',
  resubscribeSuccessful: 'Resuscripción exitosa',
  clickHere: 'Haz clic aquí',
  toGoBackToTheSite: 'para regresar al sitio',
  pleaseSelectOneOfTheReasonsBelow: 'Por favor elije una de las razones debajo',
  notEnoughUsers: 'No hay suficientes usuarios',
  complicatedToUse: 'Demasiado complicado de usar',
  notEnoughOptions: 'No hay suficientes opciones',
  betterAlternatives: 'Mejores alternativas',
  badExperienceWithAnotherUser: 'Mala experiencia con otro usuario',
  technicalIssues: 'Problemas técnicos',
  thanksForYourFeedback: 'Gracias por tus comentarios',
  tapHere: 'Toca aquí',
  // Who's online
  WhosOnline: 'Quién está en línea',
  Recent: 'Reciente',
  ThisWeek: 'Esta semana',
  MembsWereOnlineRec: 'Miembros estuvieron en línea recientemente',
  MembsWereOnlineWeek: 'Los miembros estuvieron en línea esta semana',
  MembsRecWillAppHere: 'Los miembros recientemente en línea aparecerán aquí',
  MembsThisWeekWillAppHere: 'Los miembros en línea esta semana aparecerán aquí',
  // Browse
  BrowseZero: 'Hay',
  BrowseZero2: 'Miembros',
  BrowseMembersAppear: 'Miembros aparecerán aquí',
  // Favorites
  MyFavorites: 'Mis Favoritos',
  FavoritedMe: 'Me Dieron Favorito',
  YourFavWillAppHere: 'Tus favoritos aparecerán aquí',
  MembHaveFavU: 'Miembros que te indicaron como favorito',
  MembWhoFavU: 'Miembros que te indicaron como favorito aparecerán aquí',
  NewPasswordSet: 'Contraseña nueva establecida. Ahora puedes ingresar.',
  // Password Recovery
  recoveryTittle: 'Recuperación de contraseña',
  recoveryButton: 'Restaurar contraseña',
  goBackToLogIn: 'Volver a Inicio de sesión',
  recoveryMessage1:
    'If we find an account with that email address, a password recovery will be sent.',
  NewPassword: 'Contraseña nueva',
  SetNewPassword: 'Establecer contraseña nueva',
  // Info Line
  NotShared: 'No compartida',
  // Create Account Email Register
  byCreatingYourAccount:
    'Al unirme al sitio, estoy de acuerdo con los términos del ',
  alsoAgree:
    'También acepto recibir mensajes, actualizaciones de cuenta, & ofertas especiales por correo electrónico',
  picturesDisclaimer:
    'Las imágenes se utilizan solo con fines ilustrativos y cualquier persona representada en el Contenido es un modelo',
  step: 'Paso',
  // GenderStep
  StepsTitle:
    '¡Únete a nosotros y ten citas ' +
    (config.NICHE_SINGLES
      ? config.NICHE_SINGLES
      : config.NICHE_PLURAL.replace(/\b\w/g, (c) => c.toUpperCase())) +
    ' Ya Mismo!',
  gender: 'Género',
  startMeeting: 'Empezar a Conocer Ahora',
  weNeedInfo: 'Solo necesitamos algo de información',
  iAm: 'Yo soy:',
  near: 'Cerca:',
  seeking: 'Buscando:',
  next: 'Siguiente',
  viewOtherOptions: 'Ver otras opciones',
  // LocationStep
  location: 'Ubicación',
  WhereAreYouLocated: '¡Bienvenido a Aventura!',
  WellFindMatchesInYourArea: 'Encontraremos empates en tu área',
  EnterYourCityOrLocation: 'Ingresa tu ciudad o ubicación:',
  // AgeStep
  age: 'Edad',
  howOldAreYou: '¿Cuántos Años Tienes?',
  enterAgeBelow: 'Introduce tu edad abajo',
  ageLabel: 'Edad:',
  agePlaceholder: 'Tu edad',
  ageError: 'La edad debe ser entre < y >',
  EnterYourAge: 'Ingresa tu edad:',
  // UsernameStep
  username: 'Usuario',
  chooseUsername: 'Escoge un nombre de Usuario',
  itWillBeYourBio: 'Será usado en tu biografía de perfi',
  usernamePlaceholder: 'Ejemplo: ' + getCleanUsername(config.NICHE_SINGULAR),
  chooseAUsername: 'Elige un nombre de usuario',
  usernameError: 'Este nombre de usuario no es válido',
  usernameLabel: 'Usuario',
  usernameLabelSmall: '(6-14 letras y números)',
  // EmailStep
  emailPassword: 'Correo electrónico/Contraseña',
  youAreDone: 'Ya Casi Estás...',
  createYourAccount: 'Crea tu cuenta debajo',
  createAccount: 'Crear Cuenta',
  emailError: 'Por favor ingresa una dirección de correo electrónico válida',
  passwordError: 'El largo mínimo de la contraseña es de 6 caracteres',
  ageMissingHeadline: 'Requisito de edad',
  EnterYourEmailAddress: 'Ingresa tu dirección de correo electrónico',
  RemainsConfidential: '(permanece confidencial)',
  ChooseAPassword: 'Elige una contraseña',
  Min6Car: '(min. 6 caracteres)',
  itWiilBeUsedForLogin: 'Se utilizará para iniciar sesión',
  // PasswordStep
  choosePassword: 'Elegir una contraseña',
  // EmailAndPasswordStep
  enterEmailAndPassword: 'Ingrese su correo electrónico y elija la contraseña',
  // Auto-complete
  EnterYourLocation: 'Ingresa tu ubicación',
  EnterYourCityOrZipCode: 'Coloca tu Ciudad o Código Postal:',
  enterCityOrZip: 'Enter your City or Zip Code:',
  Menu: 'Menu',
  More: 'Más',
  // Matches
  noMatchesFound: 'No se encontraron empates',
  wantMoreMatches: '¿Quieres más empates?',
  tapButtonBelow:
    'Toca el botón debajo para cambiar tus preferencias de empates',
  editMatchPreferences: 'Editar preferencias de empate',
  // MyLikes
  youHave: 'Tienes',
  increaseYourMatches:
    'Aumenta tus empates tocando el botón "Empezar a Dar Me Gusta" debajo',
  startLiking: 'Empezar a dar Me Gusta',
  // Mutual
  mutualLikes: 'Me Gusta mutuos',
  // LikesMe
  membersHaveLikedYou: 'Miembros les gustas',
  // MyViews
  youHaveViewed: 'Has visto',
  profiles: 'Perfiles',
  membersWhoYouViewed: 'Miembros que te vieron aparecerán aquí',
  // ViewedMe
  memberViewedYou: 'Miembros te vieron',
  memberWhoViewYourProfile: 'Miembro que vio tu perfil aparecerá aquí',
  // Settings
  logout: 'Cerrar Sesión',
  general: 'genera',
  account: 'cuenta',
  legal: 'lega',
  support: 'atención al cliente',
  matchPref: 'Preferencias de Empates',
  emailPref: 'Preferencias de correo electrónico',
  privacyStgs: 'Configuración de privacidad',
  reactivateVipMbership: 'Reactivar membresía VIP',
  youAreVipMember: 'Eres un miembro VIP',
  byCancelingYourVip:
    'Al cancelar tu membresía VIP, ya no tendrás acceso a las siguientes funciones una vez que tu término actual de membresía expire',
  unLimitedMessages: 'Mensajes ilimitados',
  seeAllPhotos: 'Ver todas las fotos',
  unlimtedUndo: 'Deshacer ilimitados',
  deactivateAccount: 'Desactivar Cuenta',
  deleteAccount: 'Eliminar Cuenta',
  showMe: 'Mostrarme',
  limitSearchToDistance: 'Limitar Búsqueda a Distancia',
  showAges: 'Mostrar Edades',
  men: 'Hombres',
  women: 'Mujeres',
  toastPrefUpdatedSucc: 'Preferencias Actualizadas Exitosamente',
  receiveEmail: 'Recibir Correo Electrónico',
  whenSomebodySendsNewMsg: 'Cuando alguien me envía un mensaje nuevo',
  whenSomebodyLikesMe: 'Cuando alguien me da Me Gusta',
  whenSomebodyVisitMyPof: 'Cuando alguien visita mi perfi',
  whenNewMembersComeOnline: 'Cuando hay miembros nuevos en línea',
  withDiscountPromotions: 'Con promociones de descuento',
  whenSomebodyFlirtsMe: 'Cuando alguien coquetea conmigo',
  whenSomebodyAddsMeToFavorites: 'Cuando alguien me agrega a favoritos',
  whenNearbyMembersComeOnline: 'Cuando los miembros cercanos se conectan',
  withNewWaysToMeetSingles: 'Con nuevas formas de conocer solteros',
  whenMyFavoritesComeOnline: 'Cuando mis favoritos se conectan',
  whenNearbyMembersUploadPhoto: 'Cuando los miembros cercanos suben una foto',
  whenSomebodyMatchesWithMe: 'Cuando alguien coincide conmigo',
  whenSomebodyTriesToConnectWithMe: 'Cuando alguien intenta conectarse conmigo',
  notifEmailPauseFor30Days:
    'Pausar todas las notificaciones por correo electrónico durante 30 días',
  notifEmailPausedUntil: 'Notificaciones por correo electrónico pausadas hasta',
  notifOptions: 'Opciones de notificaciones',
  notifUpdateSucc: 'Notificaciones actualizadas exitosamente',
  privacySettingsText1: 'Controla quién ve tu perfi',
  privacySettingsText2: 'Selecciona una o más opciones debajo',
  importantNotice: 'Nota importante',
  byDeactivatingYourAccount:
    'Al desactivar tu cuenta, no tendrás acceso a los siguientes hasta reactivar la misma',
  yourMatches: 'Tus empates',
  yourMessages: 'Tus mensajes',
  yourLikes: 'Tus Me Gusta',
  yourFavorites: 'Tus favoritos',
  allOtherInfo: 'Toda otra información asociada con tu cuenta',
  yourProfileWillBeHidden:
    'Tu perfil se ocultará a otros miembros. No recibirás nuestros correos electrónicos hasta que reactives tu cuenta. Toca el botón a continuación para desactivar tu cuenta',
  areYouSure: 'Estas seguro',
  yourAccountWillBeDeact: 'Tu cuenta será desactivada',
  yesDeactivateAcc: 'Sí, desactivar cuenta',
  accountSuccDeact: 'Cuenta desactivada exitosamente',
  byDeletingYourAccount:
    'Al eliminar tu cuenta, la siguiente información se eliminará permanentemente',
  infoUsedToCreate: 'Información utilizada para crear tu cuenta',
  yourPhotos: 'Tus fotos',
  yourChatHistory: 'Tu historial de chat',
  thisActionIsNotReversible: 'Esta acción no es reversible',
  tapTheButtonBellow: 'Toca el botón de abajo para eliminar tu cuenta',
  yesDeleteAccount: 'Sí, eliminar cuenta',
  accountSuccDelete: 'Cuenta eliminada exitosamente',
  byReactivatingYourVip:
    'Al reactivar tu suscripción de membresía VIP, se te facturará al final del período de facturación actua',
  tapTheButtonToReactivateVip:
    'Toca el botón de abajo para reactivar tu membresía VIP',
  yourMembershipWillExpire: 'Tu membresía expirará e',
  yourMembershpWillRenew: 'Tu membresía renovará e',
  yourVipMembershipWillReactivate: 'Tu membresía VIP se reactivará',
  yesReactivateVip: 'Sí, reactivar membresía VIP',
  noIveChangedMyMind: 'No, cambié de opinión',
  membershipSuccessfullyReactivated: 'Membresía reactivada exitosamente',
  membershipSuccessfullyCanceled: 'Membresia cancelada exitosamente',
  visibilityPreferences: 'Preferencias de visibilidad',
  onlyShowMyProfileToPeopleISendMsg:
    'Mostrar solo mi perfil a las personas a las que les envío mensajes',
  dataManagement: 'Gestión de datos',
  tapTheDownloadDataButtonBelowToViewYourAccountData:
    'Toca el botón "Descargar datos" debajo para ver los datos de tu cuenta',
  downloadData: 'Descargar datos',
  yesDownload: 'Sí, descargar',
  yourDataWillBeDownloaded: 'Tus datos serán descargados',
  changePassword: 'Cambiar contraseña',
  saveChanges: 'Guardar cambios',
  currentPassword: 'Contraseña actual',
  confirmNewPassword: 'Confirmar contraseña nueva',
  enterNewPassword: 'Ingresar contraseña nueva',
  passwordNotMatch: 'La contraseña no coincide',
  passwordChangedSuccess: 'La contraseña se modificó exitosamente',
  registredAs: 'Registrado como:',
  userID: 'ID de usuario:',
  version: 'Versión:',
  // Member
  cancel: 'Cancelar',
  reportUser: 'Reportar usuario',
  blockUser: 'Bloquear usuario',
  options: 'Opciones',
  startConversation: 'Iniciar una conversación',
  requestPhotoTap: 'Toca aquí',
  requestPhotoTapTo: 'para solicitar su foto',
  requestPhotoTapToFemale: 'para solicitar su foto',
  requestPhoto: 'Solicitar foto del usuario',
  photoAlreadyRequested: 'Foto ya solicitada',
  youAlreadyRequestedPhoto: 'Ya solicitaste la foto de este usuario',
  photoRequestSuccessfully: 'Solicitud de foto exitosa',
  tellWhy: 'Dinos por qué',
  inappropriatePhotos: 'Fotos Inapropiadas',
  inappropriateMessages: 'Mensajes inapropiados',
  badOfflineBehavior: 'Mala conducta fuera de línea',
  feelsLikeSpam: 'Parece spam',
  other: 'Otra',
  report: 'Reportar',
  reportComment: 'Reportar comentario…',
  blockMember: '¿Bloquear miembro?',
  willNoLongerAppear: 'ya no aparecerá en tu lista de Empates',
  yesBlock: 'Si, bloquear miembro',
  noCancel: 'No, Cancelar',
  userReportedSuccessfully: 'Usuario reportado exitosamente',
  userBlockedSuccessfully: 'Miembro bloqueado exitosamente',
  addedToFavorites: '¡Agregado a Favoritos!',
  removedFromFavorites: '¡Removido de Favoritos!',
  sendAMessage: 'Enviar un mensaje',
  sendUserAMessage: 'Enviar un mensaje a {user}',
  wellYouveComeThisFar:
    'Bueno, has llegado hasta aquí, bien podrías decir algo',
  chatWith: 'Chatea con',
  outOfFlirts: 'No quedan Coqueteos',
  untilYouCanSend: 'Hasta que puedas enviar un Coqueteo nuevamente.',
  wantToMakeSure: '¿Quieres estar seguro que',
  seesYou: 'te ve?',
  goVipGetFlirts: '¡Hazte VIP y consigue {num_of_flirts} coqueteos al día!',
  getMoreFlirts: 'Consigue más coqueteos',
  noNotThisTime: 'No, no en este momento',
  flirtSent: 'Coqueteo enviado y gustado',
  memberNotSharedAboutMe:
    'Este miembro no ha compartido su información Acerca de mí',
  dontWait: 'No esperes',
  chooseFlirt: 'Elegir un coqueteo:',
  sendFlirt: 'Enviar un coqueteo',
  flirtIsSent: 'Enviado',
  // Chats
  chats: 'Chats',
  sentMessages: 'Mensajes Enviados',
  yourConversations: 'Tus conversaciones con otros miembros aparecerán aquí',
  yourSentMessages: 'Tus mensajes enviados a otros miembros aparecerán aquí',
  // ChatRoom
  cannotSendMessageUnlessVip:
    "No puede enviar mensajes a menos que sea un usuario de VIp o 'Happy Hour' esté activo",
  happyHour: 'Hora Feliz',
  sendMessagesFree: 'Enviar Mensajes Gratis',
  endsIn: 'Termina en:',
  happyHourTonightAt: 'Esta noche a las ',
  happyHourTodayAt: 'Hoy a las ',
  // Contact us
  ContactUs: 'Contáctanos',
  ContactUsSupport: 'Contáctanos / Atención al cliente',
  WhatIsYourEmail: '¿Cuál es tu dirección de correo electrónico?',
  HowCanWeHelpU: '¿Cómo podemos ayudarte?',
  WriteMsg: 'Escribir mensaje...',
  SendMsg: 'Envíar Mensaje',
  EnterMsg: 'Ingresar mensaje.',
  AlertMsgSentSuccessfully: '¡Gracias! Mensaje enviado exitosamente.',
  ToastMsgSentSuccessfully: 'Mensaje enviado exitosamente',
  Subject: 'Asunto',
  subject0: 'Asuntos Generales',
  subject1: 'Membresía VIP',
  subject2: 'Reporte de Fraude',
  subject3: 'Cancelación',
  subject4: 'Eliminar Cuenta Y Todos Mis Datos',
  subject5: 'Otra',
  // Search
  refineSearch: 'Refinar Búsqueda',
  iamDoneRefining: 'He Terminado de Refinar',
  showAdvanced: 'Mostrar opciones avanzadas',
  hideAdvanced: 'Ocultar opciones avanzadas',
  cancelSearch: '¿Cancelar refinamiento de búsqueda?',
  youWillLooseYourChanges:
    'Perderás todos los cambios en tus criterios de búsqueda',
  yesLeavePage: 'Si, abandonar página',
  noContinueRefining: 'No, seguir refinando',
  zeroMembersFound: 'Miembros encontrados',
  tap: 'Tocar',
  // tapHere: 'Toca aquí',
  // uploadAPhotoHere: 'Sube una foto aquí',
  toDisplayPreviousMembers: 'para mostrar los miembros anteriores.',
  toEditCurrentFilters: 'para editar sus filtros actuales.',
  resetSearch: 'Restablecer búsqueda',
  tryAgain: 'Vuelve a intentar',
  mile: 'Milla',
  miles: 'Millas',
  noUsers: 'No hay usuarios',
  // Quick Match Button text
  undo: 'Deshacer',
  pass: 'Pasar',
  like: 'Me Gusta',
  profile: 'Perfi',
  undoNotAvailable: 'Deshacer no disponible',
  nothingToUndo: 'No hay nada que deshacer.',
  thisIsTheFirstUser: ' Este es el primer usuario.',
  dismissAd: 'Descartar',
  seeMoreHere: 'Ver más aquí',
  tryChangingYourPreferences: 'Intenta cambiar tus preferencias',
  errorOnInviteActionTitle: 'Error en Empate Rápido',
  // It's Match
  itsMutual: 'Es Mutuo',
  youAndMemberLikeEachOther: '¡Tu y {member} se gustan!',
  seeMoreMatches: 'Ver más empates',
  // My Profile
  edit: 'Editar',
  aboutMe: 'Acerca de mi',
  youHaveNotSharedAbout: 'Aún no has compartido información de Acerca de mí',
  appearance: 'Apariencia',
  situation: 'Situación',
  addPhoto: 'Agregar foto de perfi',
  // Edit Profile
  editProfile: 'Editar perfi',
  reset: 'Reiniciar',
  dob: 'Fecha de nacimiento',
  youWillLooseYourChangesProfile:
    'Perderás todos los cambios actuales que realizaste en tu perfi',
  cancelEdit: '¿Cancelar editar tu perfil?',
  noContinueEditing: 'No, continuar editando',
  invalidMonth: 'Mes no válido',
  invalidDay: 'Día no válido',
  invalidAge: 'Debes tener entre {min} y {max} años',
  invalidFebruar: 'Febrero puede tener un máximo de 28 o 29 días',
  invalid30Day: 'Este mes puede tener un máximo de 30 días',
  invalid31Day: 'Este mes puede tener un máximo de 31 días',
  invalidLocation:
    'La ubicación no es válida, por favor selecciona la ubicación de la lista desplegable',
  locationUpdated: 'Ubicación actualizada exitosamente',
  setAsMainPhoto: 'Establecer como foto principa',
  changeAsMainPhoto: 'Cambiar como foto principa',
  deletePhoto: 'Eliminar foto',
  areSureDeletePhoto: '¿Estás seguro de que quieres eliminar esta foto?',
  noKeepPhoto: 'No, conservar foto',
  yesDeletePhoto: 'Sí, eliminar foto',
  editPhoto: 'Editar foto',
  profileUpdated: 'Perfil actualizado exitosamente',
  secondaryImageAlertText:
    'Esta imagen está etiquetada como secundaria por el servicio de atención al cliente y, como tal, no se puede establecer como foto de perfil.',
  reviewImageAlertText:
    'Esta imagen aún no está aprobada por nuestro servicio de atención al cliente, intente más tarde.',
  pendingReview: 'Revisión pendiente',
  // missing location
  locationReq: 'Solicitud de ubicación',
  pleaseEnterLocation: 'Por favor ingresa tu ubicación a continuación.',
  withoutItOther: 'Sin ella, otros miembros',
  cantSee: 'no pueden verte,',
  likeOrMessage: 'darte me gusta o mandarte mensajes.',
  submit: 'Enviar',
  // missing username
  completeYourProfile: 'Completa tu perfil',
  itWillBeUsedOnYourProfileBio: 'Se usará en tu biografía de perfi',
  userNameLettersAndNumbers: '(6-14 letras y números)',
  submitUsername: 'Enviar usuario',
  unknownError: 'Ocurrió un error desconocido',
  confirmUsername: 'Confirmar nombre de usuario',
  orChooseNewOne: 'o elige uno nuevo.',
  // missing username and location
  welcomeToSite: 'Bienvenido a ' + config.TITLE,
  yourAccountIsNowActive: '¡Tu cuenta ahora está activa!',
  itsGreatToHaveYou:
    'Es genial tenerte aquí como miembro de nuestro sitio y esperamos poder ayudarte a encontrar la\u00A0pareja\u00A0perfecta.',
  // error
  somethingWentWrong: 'Algo salió ma',
  networkError: '¡Error de red! Por favor intente mas tarde.',
  // invalid Token
  invalidToken: 'Su sesión ha caducado. Por favor, inicie sesión nuevamente',
  // rejected Username
  rejectedUsername: 'Nombre de usuario rechazado',
  // missing password
  missingPassword: 'Ya casi estás...',
  missingPasswordText: 'Configura tu contraseña debajo',
  missingPasswordPlaceholder: 'mínimo 6 caracteres',
  submitPassword: 'Configurar contraseña',
  // missing email
  missingEmail: 'Nos falta tu correo electrónico',
  missingEmailText:
    'Ingresa tu dirección de correo electrónico a continuación para recibir notificaciones cuando recibas nuevos mensajes, Me gusta, empates y personas que ven tu perfil.',
  submitEmail: 'Enviar contraseña',
  // Move And Scale
  moveAndScale: 'Mover y dimensionar',
  crop: 'Recortar',
  uploadError: 'Error de carga de imagen',
  whoops: 'Whoops',
  itSeemsThatIsTaking:
    'Parece que se tarda más de lo habitual en subir una foto. Inténtalo de nuevo.',
  // Missing Photo
  photoRequest: 'Completar tu perfi',
  wait: 'Espera...',
  yourMissingPhoto: 'Te falta una foto',
  membersWithoutPhotos: 'Los miembros sin fotos tienen 65% menos',
  likelyToReceive: 'probabilidad de recibir Me Gusta y mensajes',
  submitPhoto: 'Enviar foto',
  takePhoto: 'Tomar foto',
  chooseFromLibrary: 'Elija de la biblioteca de fotos',
  // Missing Gender
  youLookingFor: 'Qué estás buscando',
  // Explicit Opt in Modal
  youAreAlmostDone: 'Ya casi estás',
  iWouldLikeToGetSpecOffers:
    'Me gustaría recibir ofertas especiales, descuentos increíbles y ventas mensuales por correo electrónico',
  iHaveReadAndAgreeToPP: 'He leído y acepto los términos de',
  ByJoiningTheSiteAgreeTos: 'Al unirte al sitio, aceptas',
  optional: 'Opciona',
  required: 'Requerido',
  continue: 'Continuar',
  // coreg
  toGetStarted: 'Para comenzar',
  tapHereToGetStarted: 'Toca aquí para comenzar',
  hello: 'Hola',
  // Upgrade Modal
  membershipStatus: 'Estado de la membresía',
  upgradeToVipChoosePlan: 'Actualiza a VIP. Escoge tu plan:',
  wantUnlimitedMessages: '¿Quieres mensajes ilimitados?',
  wantToReply: '¿Quieres responderle a %gender%? ¡Hazte VIP!',
  getUnlimitedMessages: 'Obtén mensajes ilimitados. Elige un plan:',
  needToUndoMistake: '¿Necesitas deshacer un error? ¡Hazte VIP!',
  getUnlimitedUndos: 'Obtén Deshacer ilimitados - Elije un plan:',
  whoViewedYourProfile: '¿Quién vio tu perfil? ¡Descúbrelo!',
  peopleViewedYourProfile: 'Personas vieron tu perfi',
  chooseVipPlanToSeeThem: 'Elije un plan VIP y velos:',
  wantToSeeWhoFavoritedYou: '¿Quieres ver quién te ha puesto como Favorito?',
  peopleFavoritedYou: 'Personas que te indicaron como Favorito',
  wantToSeeWhoLikesYou: '¿Quieres ver a quién le gustas?',
  peopleLikedYou: 'Personas que te dieron Me Gusta',
  youAreBasic: 'Eres un Miembro Básico',
  wantToUnlockPhotos: '¿Quieres desbloquear todas las fotos?',
  wantMoreFlirts: '¿Quieres 5 Coqueteos al día?',
  vipMembershipFeatures: 'Las opciones de Membresía VIP Premium incluyen:',
  vipMembershipFeaturesMobile: 'Los miembros VIP reciben:',
  unlimited: 'Mensajería',
  messaging: 'Ilimitada',
  meetSomeoneTonight: 'Actualiza ahora - ¡Conoce a alguien esta noche!',
  chooseVipPlanBelow: 'Elije un plan VIP debajo:',
  messagingSub: 'Mantén los chats fluyendo con tus empates',
  viewedSub: 'Mira quién ha visto tu perfi',
  likesMeSub: 'Descubre a quién le gustó tu perfi',
  unlockPhotosSub: 'Ver todas las fotos de los usuarios',
  favoritedMeSub: 'Mira quién está realmente interesado en ti',
  moreFlirtsSub: 'Aumenta tus posibilidades con 5 coqueteos al día',
  goPrivateSub: 'Controla quién ve tu perfi',
  undoSub: '¿Cometiste un error? ¡Deshaz tu deslizamiento!',
  select: 'Seleccionar',
  vipMembersReceive: 'LOS MIEMBROS VIP RECIBEN:',
  chooseYourPlan: 'ELIJA SU PLAN:',
  enterPaymentDetails: 'INGRESE SUS DETALLES DE PAGO:',
  creditCard: 'Tarjeta de crédito',
  yourSubscriptionWillRebill:
    'Su suscripción volverá automáticamente a una membresía {0} {1} en la {2} y se renovará cada {0} hasta que se cancele. Puede cancelar en cualquier momento, a través de la configuración de su cuenta.',
  byTappingButtonBelow: 'Al presionar el botón de abajo, usted acepta la',
  andAuthorizeToCharge:
    'y nos autoriza a cobrar su %CARD_TYPE% ahora y en cada renovación.',
  continueToPayPal: 'Continúe con PayPal para completar su compra.',
  proceedToPayPal: 'Pasar a PayPal',
  limitedTimeOffer: 'Oferta de tiempo limitado',
  promoHeader: 'Prueba de membresía {date} VIP para {price}',
  promoHeaderNoTrial: '{price} / {rebill_period} mes(es)',
  promoSubHeaderText: 'Esta es una oferta exclusiva para nuevos miembros',
  promoButtonText: 'Sólo {price} - {date} Prueba',
  promoRebillsText:
    '*Vuelva a completar cada {date} para {price} si la membresía VIP no se cancela antes del final del período de prueba*',
  accessToAllPhotos: 'El acceso a todas las fotos está disponible',
  unlimitedMessaging: 'Mensajería ilimitada está disponible',
  toPremiumUsers: 'solo para usuarios Premium.',
  upgradeTodayAndSendMessage: 'Actualice hoy para leer y responder mensajes de',
  upgradeTodayAndSeePhotos: 'Actualiza hoy para acceder a todas las fotos de',
  mostPopular: 'Más popular',
  notSuitableForCreditCard: '¿No es apto para pagar con tarjeta de crédito?',
  weAreAccepting: 'Nosotras estamos aceptando ',
  payPal: 'PayPal',
  // Welcome Back Modal
  weHaveAnOffer: 'Tenemos una oferta para usted:',
  discount: 'descuento',
  onVipMembership: 'en una membresía VIP!',
  tapHereToSave: 'Toque aquí para ahorrar un 50%!',
  toUnlockFeatures: 'para desbloquear todas las funciones premium',
  upgrade: 'Upgrade',
  upgradeNow: 'Actualizar ahora',
  // Invalid Tagline
  invalidTaglineHeadline: 'Descripción rechazada',
  invalidTaglineTitle: 'El texto en tu sección "Acerca de mí" no fue aprobado.',
  invalidTaglineReason: 'Razón: ',
  invalidTaglineButton: 'Actualizar descripción',
  // Invalid Tagline
  photoRejectedHeadline: 'Foto rechazada',
  photoRejectedTitle: 'Lo sentimos...',
  photoRejectedParagraph:
    'Una o más de tus fotos cargadas no fueron aprobadas.',
  photoRejectedReason: 'Razón: ',
  photoRejectedButton: 'Enviar foto nueva',
  viewed: 'Vieron',
  myProfile: 'Mi Perfi',
  unlock: 'Desbloquear',
  allPhotos: 'Todas las fotos',
  undos: 'Deshacer',
  moreFlirts: 'Más Coqueteos',
  goPrivate: 'Ir Privado',
  monthFor: 'Mes',
  monthsFor: 'Meses',
  mo: 'ms',
  month: 'mes',
  months: 'meses',
  monthly: 'mensual',
  billed: 'facturado',
  every: 'cada',
  saveUpTo: 'Ahorra hasta',
  trialFor: 'Prueba por',
  day: 'día',
  days: 'Días',
  free: 'gratis',
  trialRebillsAt: 'prueba refactura a',
  per: 'por',
  best: 'Mejor',
  value: 'Valor',
  // Checkout
  planSelected: 'Plan seleccionado',
  paymentOption: 'Opción de pago',
  billingDetails: 'Detalles de facturación',
  payByCard: 'Pagar con tarjeta',
  creditOrDebitCard: 'Pagar con tarjeta de crédito o débito',
  payWith: 'Paga con',
  pay: 'Pay',
  pal: 'Pal',
  for: 'por',
  promoRebillsAt: 'promo refactura a',
  chooseMembershipPlan: 'Elige tu plan de membresía debajo',
  choosePaymentOption: 'Elige tu opción de pago debajo',
  enterCardDetails: 'Coloca los detalles de tu tarjeta debajo',
  nameOnCard: 'Nombre en la tarjeta',
  enterFullName: 'Ingresar el nombre completo aquí',
  creditCardNumber: 'Número de tarjeta de crédito',
  cardNumber: 'Número de tarjeta',
  expirationDate: 'Fecha de expiración',
  cvv: 'CVV/Seguridad',
  pleaseEnterCvv: 'Por favor ingresar CVV',
  forYourPrivacyYouAreBilled:
    'Para tu privacidad, se te facturará de forma discreta como',
  byCompletingThisTransaction:
    'Para completar esta transacción para certificar que tienes al menos 18 años y que aceptas',
  submitAndUpgrade: 'Enviar y actualizar a VIP',
  thisIsSecurePage: 'Esta es una página segura',
  dataTransferIsEncrypted:
    'La transferencia de datos está encriptada para seguridad y protección',
  tellUsYourFullName: 'Díganos su nombre completo como en la tarjeta',
  pleaseEnterYourCreditCard:
    'Por favor ingresa tu número de tarjeta de crédito',
  pleaseEnterValidCreditCard:
    'Por favor ingresa un número de tarjeta de crédito válido',
  pleaseEnterMonth: 'Por favor ingresa el mes',
  pleaseEnterValidMonth: 'Por favor ingresa un mes valido',
  pleaseEnterYear: 'Por favor ingresa año',
  pleaseEnterValidCvv: 'Por favor ingresar un CVV válido',
  pleaseAgreeToTos: 'Por favor acepta los Términos de Servicio',
  thanksForBeingVip: 'Gracias por ser un miembro VIP',
  subscriptionUnavailable:
    'La suscripción no está disponible porque ya eres VIP',
  onTheBackOfCard: 'En el reverso de tu tarjeta puedes',
  findYour: 'encuentra tu',
  cvvCvc: 'CVV/CVC',
  codeHere: 'código aquí.',
  hurryUp: 'Darse prisa!',
  thisOfferExpires: 'Esta oferta caduca en:',
  youAreInLuck: '¡Estás de suerte!',
  thisPromoGotExtended:
    'Esta promoción se extendió. Tómelo rápido, ya que podemos retirar esta oferta en cualquier momento.',
  forYour: 'Para tu',
  privacy: 'intimidad',
  youAreBilled: 'te facturan',
  discreetly: 'discretamente',
  as: 'como',
  specialOffer: 'Oferta Especial',
  membershipInfo: 'Información de membresía',
  // Success Upgrade
  successUpgrade: 'Actualización exitosa',
  welcomeToVip: '¡Bienvenido a VIP!',
  youHaveSuccessfullyUpgraded: 'Has actualizado exitosamente a una',
  vipPremiumMembership: 'Membresía Premium VIP',
  importantInfo: '¡Información importante!',
  pleasePrintThisPage:
    'Por favor imprime esta página o anota la siguiente información. La necesitarás en el futuro para acceder o cambiar tu información de membresía.',
  yourCreditCardBilled:
    'Tu tarjeta de crédito/débito se facturará discretamente como:',
  yourPayPalCardBilled: 'Tu cuenta de PayPal se facturará discretamente como',
  youWillBeDicreetlyBilled: 'Se le facturará discretamente como:',
  membershipPurchased: 'Membresía adquirida:',
  billingTerms: 'Términos de Facturación',
  vipPremium: 'Premium VIP',
  total: 'Tota',
  vip: 'VIP',
  trial: 'Prueba',
  yourInfo: 'Tu información:',
  fullName: 'Nombre completo:',
  pleaseContactSupport:
    'Por favor contacta a atención al cliente si tienes preguntas sobre la facturación',
  billingSupport: 'Asistencia de facturación:',
  billingPhone: 'Teléfono de facturación:',
  clickToAccessVip: 'Haz clic para acceder a las funciones VIP',
  tapToAccessVip: 'Toca para acceder a las funciones VIP',
  thirtyDays: '30 días',
  // Process Payment
  processPayment: 'Por favor espera, estamos procesando tu pago...',
  paymentProcessingError: '¡Error de procesamiento de pago!',
  // Error Component
  serviceUnavailable: 'Servicio temporal no disponible',
  pleaseTryLater: 'Por favor intenta más tarde',
  // Another Client
  isOpenInAnotherWindow:
    'está abierto en otra ventana. Puedes cerrar esta ventana.',
  useInThisWindow: 'Usar en esta ventana',
  // modal alert merging
  greatNews: 'Una gran noticia,',
  weAreHappy: ' Nos complace anunciar que, vigente hoy, ',
  become:
    '{old_site} y {new_site} se han convertido en un gran sitio: {new_site}!',
  thisMeans:
    ' Esto significa una comunidad más grande para todos nuestros miembros, más coincidencias y una mayor oportunidad de encontrar a alguien especial.',
  dontWorry:
    'No te preocupes, para ti, como nuestro miembro, nada cambia. Su información de inicio de sesión, información de perfil e historial se transfirieron automáticamente, por lo que podrá continuar donde lo dejó.',
  // ads
  ad: 'Anuncio',
  sponsored: 'AUSPICIADO',
  findNiche:
    'Encontrar ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  meetNiche:
    'Conocer ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  // ads random text, this is generated like this for easy transition to another niche
  adsRandomTextMeetNiche:
    'Conocer ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSingleNiche:
    'Soltero(a) ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextFindNiche:
    'Encontrar ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextDateNiche:
    'Ten citas con ' +
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheRomance:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Romance',
  adsRandomTextLonelyNiche:
    'Solo(a)s ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheLove:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Amor',
  adsRandomTextWhantNiche:
    'Quieres ' +
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) +
    '?',
  adsRandomTextNicheDates:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Citas',
  adsRandomTextMoreNiche:
    'Más ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSearchNiche:
    'Buscar ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheNow:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Ahora?',
  adsRandomTextNichesingles:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Solteros',
  // niche gender names
  genderTsTvTg: 'TS/TV/TG',
  genderXdresser: 'Trave\u00ADsti',
  genderCouple: 'Pareja',
  genderDom: 'Ama',
  genderFem: 'Femdom',
  genderBiCouple: 'Pareja bi',
  genderSugarMale: 'Sugar Baby hombre',
  genderSugarBaby: 'Sugar Baby',
  genderHotWife: 'Esposa/\n\u00ADPareja',
  genderMan: 'Hombre',
  lookingFor: 'buscando',
  genderMilf: 'Madura',
  // onboarding
  moreInformation:
    'obtengamos un poco más de información sobre ti para que podamos encontrar otros solteros que coincidan contigo',
  howTallAreYou: '¿Cuán alto eres?',
  UseSliderHeight: 'Usa el control deslizante para especificar tu altura',
  WhatIsYourEthnicity: '¿Cuál es su origen étnico?',
  specifyYourBodyType: 'Por favor especifica tu tipo de cuerpo',
  whatYouLookingFor: 'Cuéntanos sobre tu pareja perfecta',
  idealMatchesAge: '¿Cuál es tu edad ideal para tus parejas?',
  howFarAway:
    '¿Qué tan lejos estarías dispuesto a viajar para conocer tu pareja perfecta?',
  useSliderDistance: 'Usa el control deslizante para especificar la distancia',
  toHaveYourProfile: 'Cuéntales a otros miembros sobre ti...',
  writeSomethingAboutYourself:
    'Escribe algo interesante sobre ti, algo que te describa mejor',
  uploadAPhoto: 'Subir una foto',
  thisIsImportant: '¡Esta es la característica más importante de tu perfil!',
  youOnlyHave: 'Solo tienes 1 oportunidad de causar una primera impresión.',
  tipPhoto:
    'Consejo: ¡Las fotos deben ser recientes, incluirte a ti solo y resaltar tus mejores cualidades para obtener los mejores resultados!',
  iUploadLater: 'Subiré una foto más tarde...',
  congratulations: 'Felicidades...',
  yourProfileUpdated:
    'Tu perfil ha sido actualizado y estás un paso más cerca de encontrar tu pareja perfecta.',
  specialOfferNewMembers:
    'Como oferta especial para nuevos miembros, te estamos dando un 25% de descuento en nuestros precios regulares de membresía.',
  get25OffNow: '¡Obtén un 25% menos ahora!',
  youWillBeRedirected: 'serás redirigido a la página de actualización en',
  seconds: 'segundos',
  aNewMember: 'Como nuevo miembro, calificas para un',
  get: 'Obtener',
  initialOff: '25% menos',
  selectedMembership: 'tu membresía seleccionada',
  selectYourMembership: 'Selecciona tu opción de membresía',
  oldPrice: 'Precio anterior',
  newPrice: 'Precio nuevo',
  iDontWantToPayLess: 'No, gracias, no quiero pagar menos.',
  addPhotoOnboarding: 'Subir foto',
  uploadAnotherPhoto: 'Subir otra foto',
  finish: 'Finalizar',
  ifYourDoneUploadingPhotos: 'Si has terminado de subir fotos',
  // california
  CCPATitle: 'No Vendan Mi Información Personal',
  CCPAPersonal: 'Mi Información Personal',
  youHaveAlreadyOptedOut: 'Ya has optado por no participar.',
  // TransactionProgress
  transactionProgress: 'Progreso de la transacción',
  checkingSpecialOffers: 'Consultando ofertas especiales ...',
  initializingTransaction: 'Inicializando transacción...',
  // SpecialOffer
  congratulationsSpecialOffer: '¡Felicidades!',
  youAreQualified: '¡Has calificado para una oferta especial!',
  toAcceptThisOffer:
    'Para aceptar esta oferta, toque Continuar a continuación:',
  noThanksIDontWant: 'No gracias, no quiero pagar menos.',
  forYourConvenience: 'Para su comodidad, se le cobrará nuevamente',
  on: 'en',
  andEvery: 'y cada',
  daysThereafter: 'días posteriores, a menos que se cancele.',
  off: 'apagada',
  yourSelectedMembership: 'su membresía seleccionada.',
  // Transaction Declined
  transactionDeclined: 'Transaccion rechazada',
  yourCreditCardWasNotApproved:
    'Su tarjeta de crédito no fue aprobada para nuestra oferta especial de membresía.',
  butWait: 'pero ESPERE ... aquí hay una oferta especial más',
  tryA: 'Prueba un',
  forOnly: 'por sólo',
  acceptOffer: 'Aceptar la oferta',
  membership: 'Afiliación',
  // Measure System
  measureSystem: 'Sistema de medir',
  imperial: 'Imperial',
  metric: 'Métrico',
  // kink cam banner
  viewNow: 'Ver Ahora',
  youGotAFree: 'Tienes un Gratis',
  // receipt page
  bonusMembership: 'Membresía Adicional',
  membersLoginArea: 'Área de inicio de sesión de miembros',
  // language
  language: 'Lenguaje',
  // OneClick
  signInFromReferal: 'Inicie sesión con su perfil desde el sitio de referencia',
  siteWouldLikeToAccess:
    config.TITLE +
    ' quisiera acceder a la siguiente información para registrarlo en este sitio:',
  permissionsToAccess:
    'Nombre, correo electrónico, fecha de nacimiento, ubicación y detalles básicos del perfil de citas',
  iConsentToDetailsAndRegister:
    'Doy mi consentimiento para que estos datos se utilicen para registrar mi perfil y confirmo que estoy de acuerdo ',
  allow: 'Permitir',
  byClickingAllow:
    'Al hacer clic en PERMITIR, acepta que estos datos sean utilizados por ' +
    config.TITLE +
    ' para registrarlo en el sitio de citas y confirmar que acepta los Términos y condiciones vinculados a continuación. Alternativamente, puede utilizar nuestro ',
  standardRegistrationForm: 'formulario de registro estándar',
  // SpecialOffer2x
  getFreeMembership: 'Obtenga una membresía GRATIS en{0}',
  doubleYourChances: 'Duplica tus posibilidades de conocer a alguien',
  weHavePartnered:
    'Nos hemos asociado con {0} para ayudar a aumentar las posibilidades de que nuestros miembros encuentren una coincidencia. Una vez que hagas clic en el botón de arriba, crearemos automáticamente un PERFIL 100% GRATUITO en {0} y te redirigiremos al área de miembros, para que puedas comenzar a buscar en su base de datos posibles coincidencias.',
  congratulationsYouGotFree:
    'Felicitaciones, obtuviste una membresía GRATUITA en {site_name}.',
  toGetLoggedInto: ' para iniciar sesión en el sitio.',
  // RefundCreditCard
  refundCreditCard: 'Reembolso con nueva tarjeta de crédito',
  refundCreditCardSuccess:
    'Su solicitud de reembolso se ha enviado correctamente.',
  // Nearby Connect
  nearbyConnect: 'Conexión Cercana',
  nearbyDecline: 'No gracias, no quiero enviarlo ahora, lo haré más tarde.',
  introduceMyself: 'Presentarme',
  distance: 'Distancia',
  anyDistance: 'Cualquier distancia',
  message: 'Mensaje',
  sentByNearbyConnect: 'Enviado por ConexiónCercana',
  typeYourMessageHere: 'Escribe tu mensaje aquí',
  sendThisToMyNewMatches:
    'También envíe esto a todos los partidos nuevos a medida que se unan',
  successNearbyConnect: 'Configuró con éxito la conexión cercana',
  nearbyConnectTitle:
    '¡Póngase en contacto con cientos de miembros de inmediato! Solo los usuarios que coincidan con su perfil recibirán estos mensajes. Ingrese su mensaje a continuación para comenzar:',
  nearbyConnectAlert:
    'Los mensajes de Near Connect son mensajes únicos de otros miembros reales que podrían ser tu pareja perfecta. Estos mensajes se envían automáticamente solo a los usuarios que coinciden con ese perfil de usuario.',
  nearbyUnavailable:
    'Lo sentimos, la función de NearbyConnect no está disponible en este momento. Esta función se puede utilizar una vez cada 30 días. Gracias por su comprensión.',
  nearbyFeatureUsed: 'Usaste la función de NearbyConnect con {date}.',
  toKeepNearbyFree:
    'Para mantener el NearConnect Free, lo limitamos a una sola presentación cada 30 días.',
  ifYouLikeToBeIntroduced:
    'Si desea que le presenten a más miembros, regrese por {date}.',
  nearbyConnectValentineTitle: 'Especial San Valentin',
  nearbyConnectValentineText1:
    'El día de San Valentín se acerca. Por tiempo limitado, te permitiremos enviar un ',
  nearbyConnectValentineText2: 'Mensaje de presentación GRATIS ',
  nearbyConnectValentineText3:
    'a cientos de usuarios que coinciden con sus preferencias. Simplemente ingrese su mensaje a continuación para comenzar:',
  // subscription status
  subscribeStatus: 'Estado de suscripción',
  subscritpionStatusManageLink1:
    '¡Felicitaciones! Eres un miembro VIP. Por favor visita ',
  subscritpionStatusManageLink2: ' para administrar su suscripción.',
  subscriptionUpgradeLink1: 'Usted es un miembro básico. ',
  subscriptionUpgardeLink2: '¡Actualizar a VIP ahora!',
  // Manage Nearby Connects
  manageNearbyConnects: 'Administrar conexión cercana',
  sendNewNearbyConnectMessage: 'Enviar nuevo mensaje de NearbyConnect',
  activeUntil: 'Activa hasta',
  sendToNewJoins: 'Enviar a nuevas incorporaciones',
  update: 'Actualizar',
  disable: 'Desactivar',
  nearbyConnectUpdated: 'Conexión cercana actualizada con éxito',
  nearbyConnectWillBeAvailable:
    'La Conexión Cercana estará disponible para usted la próxima vez en ',
  canChangeMessageOn: 'Puede cambiar el mensaje en',
  getInTouchWith:
    '¡Póngase en contacto con cientos de miembros de inmediato! Sólo los usuarios que coincidan con su perfil recibirán estos mensajes.',
  // Cookie Consent
  cookieConsentText:
    'El sitio utiliza cookies. Al continuar navegando por el sitio, usted acepta explícitamente el uso de cookies.',
  cookieConsentDetailsLinkText: 'Detalles',
  cookieConsentButtonText: 'Entiendo',

  cookieConsentDeclineButtonText: 'cerca',
  cookieTitle: 'Este sitio utiliza cookies',
  cookieSubTitle:
    'Utilizamos cookies y otras tecnologías de seguimiento para mejorar su experiencia de navegación en nuestro sitio web, mostrarle contenido personalizado y anuncios dirigidos, analizar el tráfico de nuestro sitio web y comprender de dónde provienen nuestros visitantes.',
  cookieAcceptAllCookies: 'Aceptar todo',
  cookieDeclineAllCookies: 'Rechazar todo',
  cookieManagePreferences: 'Cambiar mis preferencias',
  cookieClosePreferences: 'Cerrar preferencias',
  cookieNecessaryTitle: 'Necesaria',
  cookieNecessaryDescription:
    'Estas cookies son esenciales para brindarle los servicios disponibles a través de nuestro sitio web y para permitirle utilizar ciertas funciones de nuestro sitio web. Sin estas cookies, no podemos proporcionarle ciertos servicios en nuestro sitio web.',
  cookieActiveText: 'Activa',
  cookieAlwaysActiveText: 'Siempre activa',
  cookieInactiveText: 'Inactiva',
  cookieFunctionallityTitle: 'Funcionalidad',
  cookieFunctionallityDescription:
    'Estas cookies se utilizan para brindarle una experiencia más personalizada en nuestro sitio web y para recordar las elecciones que realiza cuando utiliza nuestro sitio web. Por ejemplo, podemos utilizar cookies de funcionalidad para recordar sus preferencias de idioma o recordar sus datos de inicio de sesión.',
  cookieAnalyticsTitle: 'Analítica',
  cookieAnalyticsDescription:
    'Estas cookies se utilizan para recopilar información para analizar el tráfico a nuestro sitio web y cómo los visitantes utilizan nuestro sitio web. Por ejemplo, estas cookies pueden rastrear cosas como cuánto tiempo pasa en el sitio web o las páginas que visita, lo que nos ayuda a comprender cómo podemos mejorar nuestro sitio web para usted. La información recopilada a través de estas cookies de seguimiento y rendimiento no identifica a ningún visitante individual.',
  cookieMarketingTitle: 'Marketing',
  cookieMarketingDescription:
    'Estas cookies se utilizan para mostrar publicidad que probablemente sea de su interés en función de sus hábitos de navegación. Estas cookies, tal como las proporcionan nuestros proveedores de contenido y/o publicidad, pueden combinar información que recopilaron de nuestro sitio web con otra información que han recopilado de forma independiente en relación con las actividades de su navegador web en su red de sitios web. Si elige eliminar o desactivar estas cookies publicitarias o de orientación, seguirá viendo anuncios, pero es posible que no sean relevantes para usted.',
  cookieOtherTitle: 'Otra',
  cookieOtherDescription: 'Algunas otras galletas',
  cookieSavePreferences: 'Guardar preferencias y cerrar',
  cookiePreferencesTitle: 'Elige tus preferencias',
  manageCookies: 'Administrar cookies',
  cookiesViewDetails: 'Ver detalles',
  cookiesProviders: 'Proveedores de cookies',
  cookiesYahoo:
    'Utilizado por Yahoo para la personalización de contenidos y publicidad.',
  cookiesGoogleDetectSpam: 'Se utiliza para detectar spam, fraude y abuso.',
  cookiesGoogleAds:
    'Se utiliza para personalizar los anuncios de Google en función de búsquedas e interacciones recientes.',
  years: 'años',
  year: 'año',
  cookiesGoogleAdDelivery:
    'Se utiliza para proporcionar entrega de anuncios o retargeting.',
  cookiesGoogleUseOurSite:
    'Cookie utilizada para recopilar información sobre cómo los visitantes utilizan nuestro Sitio.',
  cookiesGoogleDistinguishUsers: 'Se utiliza para distinguir usuarias.',
  cookiesGoogleCrossSite:
    'Esta cookie se utiliza para evitar que el navegador envíe esta cookie junto con solicitudes entre sitios.',
  cookiesGoogleUniqueIdTracking:
    'Estas cookies utilizan un identificador único con fines de seguimiento.',
  cookiesGoogleProtectData:
    'Cookie de seguridad para proteger los datos de un usuario del acceso no autorizado.',
  cookiesGoogleTrackConversions:
    'Se utiliza para almacenar y realizar un seguimiento de las conversiones.',
  cookiesBingAds:
    'Esta cookie permite mostrar anuncios relevantes a los visitantes.',
  cookiesBingTracking:
    'Cookie de seguimiento del identificador de usuario de Microsoft utilizada por Bing Ads.',
  cookiesBingTrackingAdvertising:
    'Esta es una cookie de seguimiento utilizada por la publicidad de Microsoft Bing para permitirnos interactuar con un visitante que ha visitado previamente nuestro sitio web.',
  cookiesBingClarityID:
    'Persiste el ID de usuario y las preferencias de Clarity, únicas para ese sitio, se atribuyen al mismo ID de usuario.',
  cookiesBingClarityMultiple:
    'Conecta múltiples vistas de página de un usuario en una única grabación de sesión de Clarity.',
  cookiesFacebookTracking:
    'Se utiliza para almacenar y realizar un seguimiento de las visitas a través de sitios web.',
  cookiesFacebookUniqueId:
    'Se utiliza para almacenar un identificador único para su navegador que, entre otras cosas, nos ayuda a protegerlo contra el fraude.',
  cookiesFacebookDevicePixelRatio:
    'Se utiliza para registrar la proporción de píxeles del dispositivo en su pantalla y si ha habilitado o no el modo de alto contraste, para que podamos representar nuestros sitios de manera óptima.',
  cookiesFacebookMarketing:
    'Se utiliza para proporcionar entrega de anuncios o retargeting.',
  cookiesGoogleDoubleClick:
    'Utilizado por Google DoubleClick para registrar e informar las acciones del usuario del sitio web después de ver o hacer clic en uno de los anuncios del anunciante con el fin de medir la eficacia de un anuncio y presentar anuncios dirigidos al usuario.',
  cookiesBingRefreshMuid: 'Indica si se debe actualizar MUID.',
  cookiesRomanceGuard:
    'Se utiliza para la detección de fraude, spam y malware.',
  cookiesTaboolaUniqueId:
    'Asigna una ID de usuario única y dividida que Taboola utiliza con fines de atribución e informes, y para personalizar recomendaciones para este usuario específico en función de las interacciones con un anunciante o editor.',
  cookiesSnapchatId: 'Se utiliza para ayudar a identificar a una visitante.',
  cookiesSnapchatTrackId:
    'Establece una identificación única para el visitante, que permite a los anunciantes externos dirigirse al visitante con publicidad relevante. Este servicio de emparejamiento lo proporcionan centros de publicidad de terceros, lo que facilita las ofertas en tiempo real para los anunciantes.',
  cookiesSnapchatPixelId:
    'Se utiliza para determinar si se llamará una etiqueta de terceros en un píxel de Snap Ads.',
  cookiesVWOVisits: 'Se utiliza para almacenar visitas únicas.',
  cookiesVWOTest: 'Se utiliza para leer si se pueden colocar cookies.',
  cookiesVWOSafari:
    'Esta galleta es un frasco de todas las galletas. Actualmente está creado sólo para el navegador Safari. En el futuro, reemplazará todas las cookies VWO. NOTA: La caducidad real de esta cookie es irrelevante ya que almacena la caducidad de las cookies configuradas en ella y continúa caducándolas.',
  cookiesVWODS:
    'Esta cookie almacena datos persistentes a nivel de visitantes para VWO Insights.',
  cookiesVWOExpiration: 'Depende del período de retención de la cuenta.',
  cookiesVWOUniqueId:
    'Esta cookie genera una identificación única para cada visitante y se utiliza para la función de segmentación de informes en VWO. También permite ver los datos de una manera más refinada.',
  cookiesVWOUniqueVisits:
    'Esta cookie calcula el tráfico de visitantes únicos en un sitio web.',
  cookiesAppsFlyer:
    'Utilizamos este servicio para detectar dispositivos de usuarios como iPhone iOS o teléfonos Android para mostrarles un banner que les informe si desean instalar una aplicación nativa desde iStore o Google Play Store.',
  cookiesTikTok:
    'Medir y mejorar el rendimiento de sus campañas publicitarias y personalizar la experiencia del usuario (incluidos los anuncios) en TikTok.',
  cookiesRaygun:
    'Raygun proporciona supervisión de errores, fallos y rendimiento para los equipos de software.',
  name: 'Nombre',
  description: 'Descripción',
  duration: 'Duración',
  url: 'URL',
  domain: 'Dominio',

  // email verification
  welcome: 'Bienvenido',
  emailConfirmationTitle:
    '¡Confirma tu correo electrónico para mantenerte conectado!',
  emailConfirmationDesc:
    'Tu correo electrónico aún no está confirmado, por lo que no estás recibiendo ningún correo electrónico o mensaje.',
  weRecomend:
    'Te recomendamos que hagas clic en el botón para reenviar el enlace, luego revisa tu correo electrónico.',
  resendConfirmation: 'REENVIAR CORREO DE CONFIRMACIÓN',
  ifForAnyReason:
    'Si por alguna razón deseas cambiar tu dirección de correo electrónico, ',
  dontSeeIt: '¿No lo ves?',
  andWeWillResend:
    'y te enviaremos el correo inmediatamente para que sea fácil de localizar.',
  checkSpamFolder: 'Revisa la carpeta de spam',
  ifYouDoNotSeeYourMessage:
    'Si no ves tu mensaje en la bandeja de entrada, revisa la carpeta de spam.',
  thenSelect: 'Luego, selecciona el mensaje y márcalo como NO ES SPAM.',
  needHelp: '¿Necesitas ayuda? ',
  ClickHereForMoreInfo: 'Haz clic aquí para más información',
  addUsToYouContacts: 'Añádenos a tu lista de contactos',
  AddUsToYourAddressBook:
    'Asegúrate de añadir notify@nearbynotifications.com a tu libreta de direcciones/lista de contactos para que tus mensajes y coqueteos lleguen a tu bandeja de entrada.',
  cantWait:
    'Estamos deseando ayudarte a encontrar tu pareja perfecta. Tenemos miles de miembros esperando para conocerte...',
  seeYou: '¡Nos vemos dentro!',
  emailConfirmationDecline:
    'No, gracias, no quiero enviarlo ahora, lo haré más tarde.',
  emailConfirmationToast:
    'Enlace de confirmación enviado con éxito. Por favor, revisa tu correo electrónico.',

  // addUsToContactsInfo
  addUsToYouContactsList:
    'Añade ' + parsed + ' a tu lista de contactos para evitar ',
  missingAnyMessage: '¡PERDERTE ningún mensaje!',
  contactsInfoDetails:
    'Añade ' +
    parsed +
    ' a tu libreta de direcciones o lista de contactos para que no te pierdas ningún mensaje o coqueteo.',
  openMessageStep:
    'Abre un mensaje del remitente que deseas guardar como contacto en Gmail.',
  hoverCursorStep:
    'Pasa el cursor sobre el nombre del remitente en la parte superior del correo electrónico.',
  selectAddToContactsStep:
    'Selecciona Añadir a Contactos en el menú emergente.',
  resendConfirmationLinkText:
    'Haz clic aquí para reenviar tu enlace de confirmación',
  toMakeItEasier:
    '¡para que sea más fácil de encontrar en tu bandeja de entrada!',
  checkGmailInbox: 'REVISA TU BANDEJA DE ENTRADA DE GMAIL',

  // checkSpamFolder
  beSure: 'Asegúrate de revisar la',
  spamFolder: 'carpeta de spam',
  ifYouDoNotSeeMessage: 'si no ves nuestro mensaje en la bandeja de entrada!',
  spamFolderDetails:
    'Si encuentras que nuestro mensaje fue clasificado erróneamente como spam, puedes desmarcar el mensaje.',
  unmarkingAMessage:
    'Desmarcar un mensaje lo moverá automáticamente a tu bandeja de entrada.',
  openSpamFolderStep:
    'Haz clic en Spam en el lado izquierdo de cualquier página.',
  selectMessageStep: 'Selecciona el mensaje.',
  markAsNotSpamStep:
    "Haga clic en 'No es spam' en la parte superior de la página.",

  // change email
  changeEmail: '¡Cambiar correo electrónico!',
  newEmailAddress: 'Nueva dirección de correo electrónico',
  currentEmailAddress: 'Dirección de correo electrónico actual',
};



// WEBPACK FOOTER //
// ./src/assets/localization/es.js